import {
  ACCEPT_JOB,
  CLEAR_POSTS,
  CLEAR_SEARCH,
  GET_POST,
  GET_POSTS,
  GET_POSTS_SEARCH,
  GET_POST_BY_ID,
} from "../constants/";

const postReducerDefaultState = {
  data: [],
  search: null,
  accepted: false,
};

const postReducer = (state = postReducerDefaultState, action) => {
  switch (action.type) {
    case GET_POSTS:
      return action.payload;
    case GET_POST_BY_ID:
      return state.data.filter(
        (item) => action.payload.id === item._id.toString()
      );
    case GET_POST: {
      const idx = state.data.findIndex(
        (item) => item._id === action.payload._id
      );

      if (idx === -1) {
        return { data: [...state.data, action.payload] };
      }
      return { data: [...state.data] };
    }
    case GET_POSTS_SEARCH: {
      return { search: action.payload.data };
    }
    case CLEAR_POSTS:
      return postReducerDefaultState;
    case CLEAR_SEARCH:
      return { search: [], data: [] };
    case ACCEPT_JOB:
      return { ...state, accepted: state.accepted === false ? true : false };
    default:
      return state;
  }
};
export default postReducer;
